/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */

import { get, post } from '../API';

const BASE_URL = 'https://api-docs-data.s3.eu-central-1.amazonaws.com';
const env = process.env.REACT_APP_API_CONFIG_ENV || 'development';

export const getDataLayerConfig = async () => {
  try {
    const response = await fetch(`${BASE_URL}/${env}/config.json`);
    const result = await response.json();
    // console.log('config result---------', result);

    return result;
  } catch (error) {
    return {};
  }
};

export const getMapBaseLayerList = async () => {
  try {
    const response = await fetch(`${BASE_URL}/${env}/map-base-layers.json`);
    const result = await response.json();

    return result;
  } catch (error) {
    return [];
  }
};

export const getMapPlaceLabelLayerList = async () => {
  try {
    const response = await fetch(
      `${BASE_URL}/${env}/map-place-label-layers.json`
    );
    const result = await response.json();

    return result;
  } catch (error) {
    return [];
  }
};

export const getMapStyle = async () => {
  try {
    const response = await fetch(`${BASE_URL}/${env}/map-style.json`);
    const result = await response.json();

    return result;
  } catch (error) {
    return {};
  }
};
